module.exports = __webpack_public_path__ + "img/spiral-details23.de4a0233.png";